module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 39
// module chunks = 0